import { render, staticRenderFns } from "./Specialtext.vue?vue&type=template&id=03a1fdd0&"
import script from "./Specialtext.vue?vue&type=script&lang=js&"
export * from "./Specialtext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports